import { getPlatform } from "../../utilities/orientationAndPlatform.js";


//returns the appropriate StationsPageTable footer pagination styling according to the platform 
export function getPaginationStyle(){
    var paginationStyle = ''

    const platform = getPlatform();

    const angle = window.screen.orientation.angle
    
    if (platform === 'mobile' && angle === 0){
        paginationStyle = {

            '& .MuiTablePagination-selectLabel': {
                display: 'block',
            },

            '& .MuiTablePagination-input': {
                display: 'inline-flex',
            },
            '& .MuiToolbar-root': {
                display: 'inline-flex',
            },

        }
    }
    else if (platform === 'desktop')
        paginationStyle = ''
    return paginationStyle;
}


//returns the appropriate StationsPageTable toolbar styling according to the platform 
//used only in the DevStationsTable
export function getToolbarStyle(){
    var toolbarStyle = '';
    var platform = getPlatform()

    const angle = window.screen.orientation.angle

    if (platform === 'mobile' && angle === 0){
        toolbarStyle = {
            '& .MuiDataGrid-toolbarContainer': {
                padding: '0'
            },
            '& .MuiButton-colorPrimary': {
                fontSize: '2.5vw'
            },
            '& .MuiSvgIcon-fontSizeMedium': {
                fontSize: '5vw'
            },
        }
    }
    else if (platform === 'desktop') toolbarStyle = ''
    return toolbarStyle
}
